module.exports = __webpack_public_path__ + "img/kermit-the-frog.dd45b24e.png";